<template>
  <!--================ banner =================-->
  <section v-if="bannerTopo != ''" class="breadcrumb_area">
    <div class="overlay bg-parallax">
      <img :src="$imagens + 'about_banner.jpg'" alt="">
    </div>
    <div class="container">
      <div class="page-cover text-center">
        <h2 class="page-cover-tittle">{{ bannerTopo[0].itiNome }}</h2>
        <ol class="breadcrumb">
          <li><router-link to="/">Home / </router-link></li>
          <li><router-link to="/blog">{{ bannerTopo[0].itiNome }}</router-link></li>
          <li v-if="linhaTextoNoticia != ''"> / <strong> {{ linhaTextoNoticia.itiNome }}</strong></li>
        </ol>
      </div>
    </div>
  </section>

  <!--================Blog Area =================-->
  <section v-if="linhaTextoNoticia != ''" class="blog_area single-post-area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 posts-list">
          <div class="single-post row ">
            <div class="container">
              <div class="col-lg-12">
                <div class="card-img-avance">
                  <img :style="{ backgroundImage: 'url(' + $imgURL + linhaTextoNoticia.insInstitucionalImagens[0].itgUrlImagem + ')' }"
                    >
                </div>
              </div>

              <div class="col-lg-12 col-md-9 blog_details">
                <h1 class="text-center" style="color: #131666;">{{ linhaTextoNoticia.itiNome }}</h1>
                <p v-html="linhaTextoNoticia.itiResumo1"></p>
                <br>

                <!-- link para voltar -->
                <div class="text-center">
                  <button onclick="history.back()" style="cursor: pointer; color: #131666;">
                    <strong><p>← Voltar</p></strong>
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
  <!--================Blog Area =================-->

</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'BlogDetalheView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    linhaTextoNoticia: [],
  }),
  methods: {
    
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Citta Forte - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Citta Forte" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    //aqui banner topo
    axios.get('/Process/InsInstitucional/institucional/27/toponoticias/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner blog')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.linhaTextoNoticia = response.data;
        this.carregaMetas(this.removerTagsHTML(this.linhaTextoNoticia.itiDescricao1), this.linhaTextoNoticia.itiNome);
        //console.log('linhaTextoNoticia')
        //console.log(this.linhaTextoNoticia)

      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>